import { Workbox } from './Workbox';
import { MyUniversalWorklist } from './MyUniversalWorklist';

/**
 * MyWorklistView component displays a summary of the user's worklist items.
 * It wraps the MyUniversalWorklist component in a Workbox for consistent styling.
 * Items are displayed in a two-column layout for optimal readability and space utilization.
 */
export const MyWorklistView = () => {
  return (
    <Workbox
      consistentHeight
      color="orange"
      title="My Worklist"
      component="MyWorklistView"
      buttonTitle="View Full Worklist"
      navigatePath="/action-center/worklist"
      subHeader="Outstanding tasks and their due dates"
    >
      <MyUniversalWorklist twoColumns />
    </Workbox>
  );
};
